// src/components/forms/AddTopic.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Loader from '../Utils/Loader';
import '../../css/addTopic.css';

const AddTopic = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetForm = () => {
    setName('');
    setDescription('');
    setError('');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    try {
      await api.post('/topics', { name, description });
      setSuccess('Topic aggiunto con successo!');
      resetForm();
    } catch (err) {
      console.error("Errore nell'aggiunta del topic:", err);
      setError("Errore nell'aggiunta del topic");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitting) {
    return (
      <div className="addtopic-container">
        <Loader />
      </div>
    );
  }

  return (
    <div className="addtopic-container">
      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}

      <h2>Aggiungi Topic</h2>
      <form onSubmit={handleSubmit} className="addtopic-form">
        <label>
          Nome del Topic:
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            placeholder="Inserisci il nome del topic"
            disabled={isSubmitting}
          />
        </label>
        <label>
          Descrizione:
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Inserisci una descrizione (opzionale)"
            disabled={isSubmitting}
          />
        </label>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <Loader /> : 'Aggiungi Topic'}
        </button>
      </form>

      {success && (
        <button
          onClick={() => navigate('/dashboard')}
          className="redirect-btn"
        >
          Vai alla Dashboard
        </button>
      )}
    </div>
  );
};

export default AddTopic;
